const PaymentMethodType = {
  CASH_ON_DELIVERY: 1,
  BANK_TRANSFER: 2,
  MOMO_WALLET: 3,
  ZALOPAY_WALLET: 4,
  WAP_LIENVIET: 101,
  BAO_KIM_WALLET: 6
}
export default PaymentMethodType
